module.exports = __webpack_public_path__ + "img/montserrat-minuscules.3057695f.jpg";